import { SET_PLATFORM } from '../actionTypes';

export const platform = (state = 'web', action) => {
  /* istanbul ignore next */
  if (action.error) return state;

  switch (action.type) {
    case SET_PLATFORM:
      return action.payload;
    default:
      return state;
  }
};
